import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AppShell } from './components/AppShell'
import { RequireAuth } from './components/RequireAuth'
import LoginPage from './pages/Login'
import AuthCallbackPage from './pages/AuthCallback'
import OverviewPage from './pages/Overview'
import SystemsPage from './pages/Systems'
import SystemDetailPage from './pages/SystemDetail'
import SystemMappingPage from './pages/SystemMapping'
import SystemOnboardingPage from './pages/SystemOnboarding'
import GatewaysPage from './pages/Gateways'
import GatewayDetailPage from './pages/GatewayDetail'
import DirectoryPage from './pages/Directory'
import PersonDetailPage from './pages/PersonDetail'
import PersonDuplicatesPage from './pages/PersonDuplicates'
import MergeDuplicatesPage from './pages/MergeDuplicates'
import PersonMembershipPage from './pages/PersonMembership'
import GroupsPage from './pages/Groups'
import GroupDetailPage from './pages/GroupDetail'
import CredentialsPage from './pages/Credentials'
import CredentialDetailPage from './pages/CredentialDetail'
import UnknownCredentialsPage from './pages/UnknownCredentials'
import AccessGroupsPage from './pages/AccessGroups'
import AccessGroupDetailPage from './pages/AccessGroupDetail'
import SchedulesPage from './pages/Schedules'
import LocationsPage from './pages/Locations'
import ZonesPage from './pages/Zones'
import DoorsPage from './pages/Doors'
import DevicesPage from './pages/Devices'
import DeviceDetailPage from './pages/DeviceDetail'
import DoorCodesPage from './pages/DoorCodes'
import EventsPage from './pages/Events'
import UnlockPage from './pages/Unlock'
import OperatorsPage from './pages/Operators'
import WebhooksPage from './pages/Webhooks'
import AuditPage from './pages/Audit'
import TrashPage from './pages/Trash'
import ProfilePage from './pages/Profile'
import WhatsNewPage from './pages/WhatsNew'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 15_000,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route element={<RequireAuth />}>
            <Route element={<AppShell />}>
              <Route path="/" element={<OverviewPage />} />
              <Route path="/systems" element={<SystemsPage />} />
              <Route path="/systems/new" element={<SystemOnboardingPage />} />
              <Route path="/systems/:uid" element={<SystemDetailPage />} />
              <Route path="/systems/:uid/mapping" element={<SystemMappingPage />} />
              <Route path="/gateways" element={<GatewaysPage />} />
              <Route path="/gateways/:uid" element={<GatewayDetailPage />} />
              <Route path="/directory" element={<DirectoryPage />} />
              <Route path="/directory/duplicates" element={<PersonDuplicatesPage />} />
              <Route path="/directory/merge" element={<MergeDuplicatesPage />} />
              <Route path="/directory/:uid" element={<PersonDetailPage />} />
              <Route path="/persons/:uid/membership" element={<PersonMembershipPage />} />
              <Route path="/groups" element={<GroupsPage />} />
              <Route path="/groups/:uid" element={<GroupDetailPage />} />
              <Route path="/credentials" element={<CredentialsPage />} />
              <Route path="/credentials/:uid" element={<CredentialDetailPage />} />
              <Route path="/unknown-credentials" element={<UnknownCredentialsPage />} />
              <Route path="/access-groups" element={<AccessGroupsPage />} />
              <Route path="/access-groups/:uid" element={<AccessGroupDetailPage />} />
              <Route path="/schedules" element={<SchedulesPage />} />
              <Route path="/locations" element={<LocationsPage />} />
              <Route path="/zones" element={<ZonesPage />} />
              <Route path="/doors" element={<DoorsPage />} />
              <Route path="/devices" element={<DevicesPage />} />
              <Route path="/devices/:uid" element={<DeviceDetailPage />} />
              <Route path="/door-codes" element={<DoorCodesPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/unlock" element={<UnlockPage />} />
              <Route path="/operators" element={<OperatorsPage />} />
              <Route path="/webhooks" element={<WebhooksPage />} />
              <Route path="/audit" element={<AuditPage />} />
              <Route path="/whats-new" element={<WhatsNewPage />} />
              <Route path="/trash" element={<TrashPage />} />
              <Route path="/profile" element={<ProfilePage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
